import { useAuth } from '../../../auth/auth-context'
import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'
import * as DateFns from 'date-fns'

export default function TransactionReport() {
    const {user} = useAuth()
    const { doFetch } = useFetch()
    const isPublisher = user?.kind === 'publisher'
    const columns = getColumns(isPublisher)
    
  return (
    <Table 
        columns={columns} 
        getData={async (fromDate, toDate) => {
            const res = await doFetch('/data/get-transactions', {
                fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
            })
            const data = await res.json()
            for(const d of data) {
                d.formattedDate = DateFns.format(new Date(d.date), 'yyyy-MM-dd HH:mm:ss')
            }

            return data
        }}
        title='Transaction Report'
        defaultSort='date'
    />)
}

